<template>
  <div class="page" id="page-insurance-detail" style="font-family:NanumSquareOTF; height: auto;">

    <div class="header">
    <div class="container">
      <div class="section-insure">
        <div class="banners">
          <div class="banner">비교견적</div>
          <div class="banner schema">정비·수리</div>
        </div>

        <template>
          <div class="title" style="margin-top: 30px;">{{ repairEstimateCompare.company_name }}</div>
        </template>
      </div>

      <template>
        <div class="repair-estimate-detail-contents">
          <div class="contents-label">상호명</div>
          <div class="contents-value">{{repairEstimateCompare.company_name}}</div>
        </div>
        <div class="repair-estimate-detail-contents">
          <div class="contents-label">주소</div>
          <div class="contents-value">{{repairEstimateCompare.address}}<span class="search-map" @click="searchMap">지도보기</span></div>
        </div>
        <div class="repair-estimate-detail-contents">
          <div class="contents-label">전화번호</div>
          <div class="contents-value">{{repairEstimateCompare.tel_number}}</div>
        </div>
        <div class="repair-estimate-detail-contents">
          <div class="contents-label">총견적가</div>
          <div class="contents-value">{{ Number(repairEstimateCompare.amount) | number }}원</div>
        </div>
        <div class="repair-estimate-detail-contents">
          <div class="contents-label">견적상세내용</div>
          <div class="contents-value">{{repairEstimateCompare.memo}}</div>
        </div>
        <div class="repair-estimate-detail-contents" v-if="canceled">
          <div class="contents-label">예약확정</div>
          <div class="contents-value contents-canceled">{{accidentDetail.detail.reservation_confirmed_date}}(취소됨)</div>
        </div>
        <div class="repair-estimate-detail-contents" v-else-if="accidentDetail.detail.reservation_confirmed_date">
          <div class="contents-label">예약확정</div>
          <div class="contents-value contents-value-strong">{{accidentDetail.detail.reservation_confirmed_date}}</div>
        </div>
        <div class="repair-estimate-detail-contents" v-else>
          <div class="contents-label">예약희망</div>
          <div class="contents-value">{{accidentDetail.detail.desired_reservation_date}} {{accidentDetail.detail.desired_reservation_date_ampm}}</div>
        </div>

<!--          <div v-if="item.label === '견적상세내용'" class="contents-label" style="display: none;" />-->
<!--          <div v-else-if="repairEstimateCompare[item.value] === ''" class="contents-label" style="display: none;" />-->
<!--          <div v-else class="contents-label">{{ item.label }}</div>-->
<!--          <div v-if="item.label === '총견적가'"-->
<!--            class="contents-value" style="font-weight:bold;">-->
<!--            {{ Number(repairEstimateCompare[item.value]) | number }}원-->
<!--          </div>-->
<!--          <div v-else-if="item.label === '주소'"-->
<!--            class="contents-value">-->
<!--            {{ repairEstimateCompare[item.value] }} <span class="search-map" @click="searchMap">지도보기</span>-->
<!--          </div>-->
<!--          <div v-else-if="item.label === '견적상세내용'" style="display:none;" />-->
<!--          <div v-else-if="item.value === ''" style="display:none;" />-->
<!--          <div v-else-if="item.label === '예약희망' && accidentDetail.detail.repair_estimate_status === '예약취소'" class="contents-value contents-canceled">{{ repairEstimateCompare[item.value] }} (취소됨)</div>-->
<!--          <div v-else :class="item.label === '예약희망' && accidentDetail.detail.desired_reservation_date ? ['contents-value', 'contents-value-strong'] : 'contents-value'">{{ accidentDetail.detail.desired_reservation_date }}</div>-->
      </template>

      <template v-if="!canceled && accidentDetail.detail.desired_reservation_date">
        <div style="margin-top:30px; margin-bottom: -30px;">
          <ul class="buttons">
            <router-link tag="li" class="button schema"
            :to="{ name: 'EstimateConsultation', query: { ectype: '정비수리비교', admin: accidentDetail.manager.adminid, customer: $store.state.customer.profile._id } }">
              예약변경 상담예약
            </router-link>
            <li class="button" @click="openKakao(accidentDetail.manager.kakaotalk)">담당사원 카카오톡</li>
          </ul>
        </div>
      </template>

    </div>
    </div>

    <div class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="30">

          <div class="section-information clear">
            <div style="color: #999999; margin-bottom: 10px;">
              견적상세내용
            </div>
            <div>
              <p>견적상세내용</p>
              <p>
                {{ repairEstimateCompare.memo }}
              </p>
            </div>
          </div>
        </masonry>

      </div>
    </div>

    <!-- 하단부 버튼 -->
    <div v-if="!canceled && accidentDetail.detail.desired_reservation_date" class="btn-double">
      <router-link tag="div" class="left"
        :to="{ name: 'EstimateConsultation', query: { ectype: '정비수리비교', admin: accidentDetail.manager.adminid, customer: $store.state.customer.profile._id } }" >
        예약변경 상담
      </router-link>
      <div class="right" @click="openKakao(accidentDetail.manager.kakaotalk)" >담당사원 카카오톡</div>
    </div>
    <ButtonBottom
      v-else
      btnTitle="예약"
      :click="reservation">
    </ButtonBottom>
  </div>
</template>

<script>
import ButtonBottom from '@/components/Elements/ButtonBottom'
import Vue from 'vue'
import { Checkbox, Rate } from 'element-ui'
import moment from 'moment'

Vue.use(Checkbox)
Vue.use(Rate)

  export default {
    components: { ButtonBottom },
    data() {
      return {
        repairEstimateCompare: {},
        // 예약한 가게인지 아닌지 확인
        selected: null,
        canceled: false,
        // 견적서 상세 내용
        contentsData: [],
        accidentDetail:
          {
            estimate_type: '예약',
            detail: {
            },
            manager: {
              title: "담당사원 정보",
            }
          },
      }
    },
    created(){
      this.insureType = 'accident'
      this.contentsData = [
        { label: '상호명', value: 'company_name' },
        { label: '주소', value: 'address' },
        { label: '전화번호', value: 'tel_number' },
        { label: '총견적가', value: 'amount' },
        { label: '견적상세내용', value: 'memo' },
        { label: '예약희망', value: 'memo' },
      ]
      if ( this.$route.query.selected ) {
        this.selected = Boolean(this.$route.query.selected)
      }
      if ( this.$route.query.canceled ) {
        this.canceled = Boolean(this.$route.query.canceled)
      }
      this.get_repair_estimate_compare()
    },
    // mounted() {
    //   const script = document.createElement('script')
    //   script.type = "text/javascript"
    //   script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=86848acd3a18a70fbe7c4f772d9e7815"
    //   document.head.appendChild(script)
    // },
    methods: {
      get_repair_estimate_compare() {
        return this.$store.dispatch('repair/getCompareItem', { repairCompareId: this.$route.query.repairCompareId })
          .then(({data}) => {
            this.repairEstimateCompare = data.data
            this.get_repair_estimate(data.data.repair_estimate_id)
          })
      },
      get_repair_estimate(repairId) {
        this.$store.dispatch('repair/get', { repairId })
          .then(({data: {data: item}}) => {
             this.insureType = item.repair_estimate_type
             this.accidentDetail = {
               _id: item._id,
               detail: {
                 repair_estimate_status: item.repair_estimate_status,
                 desired_reservation_date: item.desired_reservation_date && moment(item.desired_reservation_date).format('YYYY.MM.DD'),
                 reservation_confirmed_date: item.reservation_confirmed_date && moment(item.reservation_confirmed_date).format('YYYY.MM.DD HH:mm:ss'),
                 desired_reservation_date_ampm: item.desired_reservation_date_ampm,
                 client: item.customer_name,
                 client_contact: item.customer_phone_number,
                 address: item.desired_area,
                 date: moment(item.repair_estimate_date).format('YYYY.MM.D a h:mm:ss'),
                 carInfo: item.autocode_name,
                 service: item.repair_items,
                 clientSpeak: item.reservation_memo,
               },
               manager: {
                 title: "담당사원 정보",
                 name: item.admin_name,
                 adminid: item.admin_id_report,
                 email: item.admin_email,
                 profileUrl: item.adminProfileUrl,
                 phone: item.admin_contact_phone,
                 kakaotalk: 'https://pf.kakao.com/_UhAjxl/chat',
               }
             }
           })
      },
      reservation () {
        // 예약 페이지로 이동
        this.$router.push({ name: 'ReservationRepair', query: { repairCompareId: this.repairEstimateCompare._id, companyId: this.repairEstimateCompare.company_id } })
      },
      searchMap () {
        // 가져온 주소로 카카오맵 검색
        window.open(`https://map.kakao.com/link/search/${this.repairEstimateCompare.address}`, '_blank').focus()
      },
      openKakao(link){
        window.open(link);
      },
    }
  }
</script>

<style lang="scss">
  .repair-estimate-detail-contents {
    display: flex;
    flex-direction: row;

    .contents-label {
      padding-left: 15px;
      flex: 1 0 20%;
      color: #999999 ;
    }
    .contents-value {
      flex: 1 0 80%;
      .search-map {
        cursor: pointer;
        color: #174BE6;
        text-decoration: underline;
      }
    }
    .contents-value-strong {
      font-weight: bold;
      color: #00CD34;
    }
    .contents-canceled {
      color: #999999;
    }
  }
</style>
